export default "__VITE_ASSET__D8Z0fI5M__"